import { useAuthStore } from "@/store/auth.store";
import { redirect } from "@tanstack/react-router";

interface RequireAuthParameters {
  location: Location;
}

export const protectedRoute = ({
  location,
}: RequireAuthParameters): void | ReturnType<typeof redirect> => {
  const { user } = useAuthStore.getState();
  if (!user) {
    return redirect({
      to: "/",
      search: {
        redirect: location.href,
      },
    });
  }

  return undefined;
};
